<template>
  <v-card outlined class="entity-sidebar-card mb-4">
    <v-card-title v-if="title" class="entity-sidebar-card__title">
      <v-icon v-if="icon" small class="mr-2" :color="iconColor">{{ icon }}</v-icon>
      {{ title }}
    </v-card-title>
    <v-divider v-if="title" />
    <v-card-text :class="{ 'pt-4': title }">
      <slot />
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EntityDetailSidebarCard",
  props: {
    title: { type: String, default: "" },
    icon: { type: String, default: "" },
    iconColor: { type: String, default: "primary" },
  },
});
</script>

<style scoped lang="scss">
.entity-sidebar-card {
  border-radius: 12px !important;
  border-color: rgba(0, 0, 0, 0.08) !important;
}

.entity-sidebar-card__title {
  font-size: 0.95rem !important;
  font-weight: 700 !important;
  color: #1f243f !important;
  padding: 14px 16px !important;
}
</style>
